<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    style="top: 5%; height: 85%; overflow-y: hidden"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" ref="resultForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色名称">
          <a-input placeholder="请输入角色名称" v-decorator.trim="['roleName', validatorRules.roleName]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属系统">
          <a-select
            placeholder="请选择所属系统"
            :default-active-first-option="true"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="null"
            @change="handleChange1"
            v-decorator.trim="['appId', validatorRules.appId]"
          >
            <a-select-option v-for="d in data" :key="d.value">
              {{ d.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色编码">
          <a-input
            placeholder="请输入角色编码"
            :disabled="roleDisabled"
            v-decorator.trim="['roleCode', validatorRules.roleCode]"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="描述">
          <a-textarea :rows="5" placeholder="..." v-decorator="['description', validatorRules.description]" />
        </a-form-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上传图片">
          <a-upload
            name="upfile"
            :multiple="false"
            :action="uploadAction"
            :data="uploadData"
            :headers="headers"
            :file-list="fileAvatarList"
            @change="handleChange2"
          >
            <a-button> <a-icon type="upload" />上传图片 </a-button>
          </a-upload>
        </a-form-model-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import JImageUpload from '@/components/jeecg/JImageUpload'
import pick from 'lodash.pick'
import { addRole, editRole, checkRoleCodeByAppId, sysInfoall, FileUpload } from '@/api/api'
import CUpload from '@/components/cusComponent/CUpload'
import { ACCESS_TOKEN, APPID } from '@/store/mutation-types'
import Vue from 'vue'
export default {
  name: 'RoleModal',
  components: {
    JImageUpload,
    CUpload
  },
  data() {
    return {
      fileAvatarList: [{}],
      iconGroup: '', //上传图片
      uploadAction: `${window._CONFIG['fileUrl']}/uploader/notChunkUploader`,
      iconUrl: '',
      title: '操作',
      visible: false,
      roleDisabled: true, //角色编码
      model: {},
      data: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      headers: {
        authorization: 'authorization-text',
        'X-Access-Token': Vue.ls.get(ACCESS_TOKEN),
        appId: Vue.ls.get(APPID)
      },
      uploadData: {
        filename: '',
        attachGroup: '',
        attachName: ''
      },
      validatorRules: {
        appId: {
          rules: [{ required: true, message: '请选择所属系统!' }]
        },
        roleName: {
          rules: [
            { required: true, message: '请输入角色名称!' },
            { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
          ]
        },
        roleCode: {
          rules: [
            { required: true, message: '请输入角色名称!' },
            { min: 0, max: 64, message: '长度不超过 64 个字符', trigger: 'blur' },
            { validator: this.validateRoleCode }
          ]
        },
        description: {
          rules: [{ min: 0, max: 126, message: '长度不超过 126 个字符', trigger: 'blur' }]
        }
      }
    }
  },
  created() {
    this.getInfos()
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()

      this.model = Object.assign({}, record)
      this.visible = true

      this.fileAvatarList = []

      //编辑页面禁止修改角色编码
      console.log(record)
      if (this.model.id) {
        this.roleDisabled = true
      } else {
        this.roleDisabled = true
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'roleName', 'description', 'roleCode', 'appId'))
      })
    },
    close() {
      this.$emit('close')
      this.form.resetFields()
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let formData = Object.assign(this.model, values)
          let obj
          console.log(formData)

          formData.iconGroup = this.iconGroup
          formData.iconUrl = this.iconUrl

          if (!this.model.id) {
            obj = addRole(formData)
          } else {
            obj = editRole(formData)
          }
          obj
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validateRoleCode(rule, value, callback) {
      if (/[\u4E00-\u9FA5]/g.test(value)) {
        callback('角色编码不可输入汉字!')
      } else {
        var params = {
          // tableName: "sys_role",
          // fieldName: "role_code",
          id: this.model.id,
          roleCode: value,
          appId: this.model.appId
        }
        checkRoleCodeByAppId(params).then((res) => {
          if (res.result) {
            callback()
          } else {
            callback(res.message)
          }
        })
      }
    },
    getInfos() {
      const that = this
      sysInfoall(null).then((res) => {
        if (res.success) {
          const result = res.result
          result.forEach((m) => {
            that.data.push({
              value: m.appId,
              text: m.appCnName
            })
          })
        }
      })
    },
    handleSearch(value) {
      // fetch(value, data => (this.data = data));
    },
    handleChange1(value) {
      this.value = value
      this.model.appId = value
      if (value) {
        this.roleDisabled = false
      }
      // fetch(value, data => (this.data = data));
    },
    handleChange2(value) {
      let fileList = [...value.fileList]
      fileList = fileList.slice(-1)
      console.log(fileList)
      let res = fileList[0].response
      console.log(res)
      if (res) {
        this.iconGroup = res.result.attachGroup
        this.iconUrl = res.result.attachPath
      }
      this.fileAvatarList = fileList
    }
  }
}
</script>

<style scoped></style>
